import type { SVGProps } from 'react';

const EligibilityIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7 0.875C4.24 0.875 2 3.115 2 5.875C2 7.55 2.98 9.02 4.375 9.688V12.375L7 11.125L9.625 12.375V9.688C11.02 9.02 12 7.55 12 5.875C12 3.115 9.76 0.875 7 0.875Z"
      stroke="currentColor"
      strokeWidth="1"
      fill="none"
    />

    <path
      d="M5.15 6.1L6.3 7.25L8.85 4.7"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default EligibilityIcon;
